/* eslint-disable no-undef */
document.addEventListener('DOMContentLoaded', function() {
  document.body.classList.add('loaded');
});
